import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription, combineLatest } from 'rxjs';

import { AppService } from '@app/services/app/app.service';
import { ProjectsService, ProjectsEditorService } from '@app/services/app/projects.service';
import { LibraryService } from '@app/services/app/library.service';
import { TitleService } from '@core/services/title.service';
import { AccessProject, AccessProjectKeys } from '@app/models/access';
// import { WebsocketService } from '@core/services/websocket/websocket.service';

import * as Objects from '@core/objects';
import { AccountSession } from '@core/objects/account-session';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { AppRouterService } from '@app/services/app/router.service';
import { HttpErrorResponse } from '@angular/common/http';
import { VersionsService, VersionsViewService } from 'app/services/app/versions.service';

@Component({
    selector: 'project-details-versions-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class ProjectDetailsVersionsMainComponent implements OnInit, OnDestroy{

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_ALLOWED = 2;
    public readonly STATUS_ERROR = 3;
    public readonly STATUS_NOT_FOUND = 4;

    protected readonly APP_FILECOMPARISON = 'filecomparison';
    protected readonly PLUGIN_SEND_FILES = 'share_transfer';
    protected readonly PLUGIN_REQUEST_FEEDBACK = 'share_feedback';
    protected readonly ACCESS_UPLOAD_VERSION = "access_request_upload_version";
    protected readonly ACCESS_GLOBAL_XRAY = "access_global_xray";
    protected readonly PLUGIN_APOLLO = 'apollo'; // transitional: also gate "Compare" on this until apollo is fully retired
    // protected readonly ACCESS_PREVIOUS_VERSIONS = "access_request_previous_versions";

    public pluginsAccess: Array<string> = [];
    public appsAccess: Array<string> = [];
    public accessGlobalXray: boolean = true;
    public accessProject: AccessProject;
    public forbidden: boolean = true;
    public status: number = this.STATUS_LOADING;

    public accessUploadVersion: boolean = false;

    public project: Objects.Request;
    public relateds: Array<Objects.RelatedVersions> = null;
    private hasOriginVersion: boolean;

    public breadcrumbs: any = [
        {
            title: "",
            link: ['']
        }
    ];

    public menu: Array<ThreeDotsMenuItem> = [];

    // main versions: optional  menu items
    protected addGroupMenuItem: ThreeDotsMenuItem =  {
        title: "Upload Group Artwork",
        key: "add-group",
        icon: "add-group",
        order: 1
    };
    protected sendMenuItem: ThreeDotsMenuItem = {
        title: "Send",
        key: "send-files",
        icon: "send-files",
        order: 2
    }
    protected feedbackMenuItem: ThreeDotsMenuItem = {
        title: "Request Feedback",
        key: "feedback",
        icon: "feedback",
        order: 3
    }

    protected menuCompare: ThreeDotsMenuItem = {
        title: "Compare",
        key: "compare",
        icon: "compare",
        order: 4
    };

    protected menuComparison: ThreeDotsMenuItem = {
        title: "NEW Filecomparison",
        htmltitle: "<strong>NEW</strong> Filecomparison",
        key: "comparison",
        icon: "compare",
        order: 5
    };

    protected subs = new Subscription();

    constructor(
        public app: AppService,
        private appRouter: AppRouterService,
        private projectsSrv: ProjectsService,
        private librarySrv: LibraryService,
        private editorSrv: ProjectsEditorService,
        private title: TitleService,
        private viewVersionsSrv: VersionsViewService,
        // private websocket: WebsocketService,
        private versionsSrv: VersionsService
    ){}

	ngOnInit(){
        this.projectsSrv.loadRelatedVersions();
        // HERE LOAD version status Access on Library Store. 
        // this.librarySrv.loadVersionsStatusAccess();

        this.viewVersionsSrv.clear();
        this.subs.add(
            this.projectsSrv.selectRelatedVersions().subscribe((relatedsList: Array<Objects.RelatedVersions>) => {
                if(relatedsList != null){
                    this.relateds = relatedsList;
                    this.init();
                    
                } 
            })
        );
        // get plugins access
        this.title.set("Artworks - Project...");
        this.subs.add(
            combineLatest([this.app.getSession(), this.app.getAccountSession()]).subscribe( ([session, accountSession]: [any, AccountSession]) => {
                this.pluginsAccess = session.options.plugins;
                // apps list now comes from the accounts-api session; fall back to the legacy session field
                // in case the (separate, parallel) accounts-api call hasn't resolved yet
                this.appsAccess = accountSession?.current?.apps ?? session.options.organization.apps;
                this.accessGlobalXray = session.options.access?.hasOwnProperty(this.ACCESS_GLOBAL_XRAY) ? session.options.access[this.ACCESS_GLOBAL_XRAY] : true;
                // this.updateMenu(this.sendMenuItem,this.checkPluginAccess(this.PLUGIN_SEND_FILES));
                // this.updateMenu(this.feedbackMenuItem,this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK));
                this.init();
            })
        );
        // subscribe to access of versions
        this.subs.add(
            this.editorSrv.selectAccess(this.ACCESS_UPLOAD_VERSION)
            .subscribe((access: boolean) => {
                this.accessUploadVersion = access;
                this.updateMenu(this.addGroupMenuItem,this.accessUploadVersion);
            })
        );
        this.subs.add(this.editorSrv.selectAccessAll().subscribe((access: AccessProject) => {
            if (access == null)
                return;
            this.accessProject = access;    
            this.init();               
        }));

        this.subs.add(
            this.projectsSrv.selectProject().subscribe((project: Objects.Request ) => {
                if(project == null) return;

                this.setProject(project);
            })
        );

        this.subs.add(
            this.projectsSrv.selectError('load_project_related_versions').subscribe((error: HttpErrorResponse) => this.setError(error))
        );


        this.subs.add(
            this.projectsSrv.selectOriginVersion().subscribe((version: Objects.Version) => {
                // if (version != null) {
                    this.hasOriginVersion = (version != null);
                    this.init();
                // }
            })
        );

	}

    ngOnDestroy() {
        this.subs.unsubscribe();
        this.projectsSrv.clearRelatedVersions();
    }

    init() {
        // TODO SET PLUGINS MENU AFTER get versions and get access together to show prroper menus 
        if (this.relateds == null || this.project == null || typeof this.hasOriginVersion === 'undefined' || this.accessProject == null || this.pluginsAccess == null || this.appsAccess == null)
            return;

        this.relateds.length == 0 && !this.hasOriginVersion ? this.updatePluginsMenu(false) : this.updatePluginsMenu(true);
        this.status = this.STATUS_DONE;
    }

    protected setProject(project: Objects.Request) {
        this.project = project;
        this.updateBreadcrumbs(project);
        this.title.set("Artworks - Project "+this.project.id+"");
        this.init();
    }

    protected checkPluginAccess(plugin: string){
        return this.pluginsAccess.some((pa) => pa == plugin);
    }

    protected checkAppAccess(app: string){
        return this.appsAccess.some((a) => a == app);
    }

    protected checkCompareAccess(): boolean {
        return this.accessGlobalXray && this.checkPluginAccess(this.PLUGIN_APOLLO);
    }

    protected checkFilecomparisonAccess(): boolean {
        return this.accessGlobalXray && this.checkAppAccess(this.APP_FILECOMPARISON);
    }

    protected updatePluginsMenu(include: boolean){
        this.updateMenu(this.sendMenuItem, include && this.checkPluginAccess(this.PLUGIN_SEND_FILES) && this.accessProject.hasOwnProperty(AccessProjectKeys.SEND_FILE) && this.accessProject[AccessProjectKeys.SEND_FILE]);
        this.updateMenu(this.feedbackMenuItem,include && this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK) && this.accessProject.hasOwnProperty(AccessProjectKeys.SEND_REQUEST_FEEDBACK) && this.accessProject[AccessProjectKeys.SEND_REQUEST_FEEDBACK]);
        this.updateMenu(this.menuCompare,include && this.checkCompareAccess());
        this.updateMenu(this.menuComparison,include && this.checkFilecomparisonAccess());
    }

    onMenuClick(key: string) {
        switch(key) {
            case "add-group":
                // console.debug(" add new version group ");
                this.appRouter.navigate('/projects/'+this.project.id+'/versions/add');
                break;
            case "feedback":
                // console.debug("feedback click ");
                // @deprecated oct-2026: legacy plugin prefix route
                // this.appRouter.navigate('/p/feedback/'+this.project.id)
                this.appRouter.navigate('/feedback/project/'+this.project.id)
                break;
            case "send-files":
                // console.debug("send files click ");
                this.appRouter.navigate('/p/transfer/'+this.project.id);
                break;
            case "compare":
                this.appRouter.navigate('/p/apollo/request/'+this.project.id);
                break;
            case "comparison":
                this.appRouter.navigate('/filecomparison/project/'+this.project.id);
                break;
        }
    }

    protected updateBreadcrumbs(project: Objects.Request){
        this.breadcrumbs[0].link = '/projects/'+project.id;
        this.breadcrumbs[0].title = 'Project <small>(#'+project.id+ ')</small>';
    }

    // this function check either remove or add item. based on subscribed events
    protected updateMenu(item: ThreeDotsMenuItem, addItem:boolean = true) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        if(addItem){
            this.menu.push(item);
        }
    }

    // the common tags between project and version should be all of the project.
    protected isRelated(version: Objects.Version){
        let common = this.project.labels.filter((pl: Objects.Label) => version.labels.some((vl: Objects.Label) => vl.id == pl.id));
        return (common.length == this.project.labels.length);
    }

    protected setError(error: HttpErrorResponse) {
        if(error == null)
            return;

        switch(error.status) {
            case 500:
                this.status = this.STATUS_ERROR;
                break;
            case 404:
                this.status = this.STATUS_NOT_FOUND;
                break;
            case 403:
                this.relateds = null; // clean saved versions, 
                this.status = this.STATUS_NOT_ALLOWED;
                break;
        }
    }
    /**
     * @deprecated marked as deprecated because seems not to be used anymore. It's call is commented
     * <diego@twonas.com> 25/4/2025
     * the getHeadersById$ was removed as well
     */
    // protected checkToUpdate(versionId: number){
    //     this.isRelatedSubscriptor = this.versionsSrv.getHeadersById$(versionId).subscribe({
    //         next: (version: Objects.Version) => {
    //             if(version != null && this.isRelated(version)){
    //                 setTimeout(()=>{ // maybe we don't need the timeout but cache system delays tag addition
    //                     this.projectsSrv.loadRelatedVersions();
    //                 }, 1000);
                    
    //             }
    //         },
    //         error: (error) => {  // version not allowed
    //             this.projectsSrv.loadRelatedVersions();
    //         }
    //     })
    // }

}
